/* eslint-disable @typescript-eslint/ban-ts-comment */
import summaryCommonStore from "@/store/summaryCommon.store";
import { formatRecordTime } from "@/utils/formatter";
import Textarea from "@/component/Textarea";
import summaryChapterStore from "@/store/summaryChapter.store";
import IC_NONE from "@/assets/record/ic_none.png";
import ImagePreviewer, { ImagePreviewerRef } from "@/component/ImagePreviewer";
import { useMemo, useRef } from "react";
import Keyframe from "@/sections/Summary/Keyframe";
import SummarySkeleton from "../SummarySkeleton";
import avPlayerStore from "@/store/avPlayer.store";

const Chapter = () => {
  const audioInfo = summaryCommonStore((state) => state.audioInfo);
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const chapterInfo = summaryChapterStore((state) => state.chapterInfo);
  const modifyChapterInfo = summaryChapterStore(
    (state) => state.modifyChapterInfo
  );
  const newChapterInfo = summaryChapterStore((state) => state.newChapterInfo);
  const retryStatus = summaryCommonStore((state) => state.retryStatus);
  const chapterLoading = summaryChapterStore((state) => state.chapterLoading);
  const keyframeArr = summaryChapterStore((state) => state.keyframeArr);
  const chapterList = chapterInfo?.srcChapterList;
  const newChapterList = newChapterInfo?.srcChapterList;
  const renderingChapterList = summaryEditing ? newChapterList : chapterList;

  const isRetrying = retryStatus === 1;

  const imagePreviewerRef = useRef<ImagePreviewerRef>(null);

  const handleClickTimeLine = (time: number) => {
    const audioPlayerIns = avPlayerStore.getState().audioPlayerIns;
    audioPlayerIns?.setCurrentTime(time);
  };

  const handleContentChange = (content: string, index: number) => {
    if (!renderingChapterList) return;
    const newChapterList = renderingChapterList.map((chapter, i) => {
      if (i === index) {
        return { ...chapter, summary: content };
      }
      return chapter;
    });
    modifyChapterInfo({ srcChapterList: newChapterList });
  };

  const handleTopicChange = (topic: string, index: number) => {
    if (!renderingChapterList) return;
    const newChapterList = renderingChapterList.map((chapter, i) => {
      if (i === index) {
        return { ...chapter, topic };
      }
      return chapter;
    });
    modifyChapterInfo({ srcChapterList: newChapterList });
  };

  const handlePreview = (keyframeIndex?: number) => {
    const images = chapterKeyframesArr.flat();
    const imageUrls = images.map(item=>item.keyFrameUrl);
    imagePreviewerRef.current?.handlePreview(imageUrls, keyframeIndex)
  }

  const chapterKeyframesArr = useMemo(
    () =>{
      if(renderingChapterList && keyframeArr){
        let keyframeIndex = 0;
        const formatKeyframeArr = keyframeArr.map(item=>{
          const chapterIndex = renderingChapterList.findIndex(chapter=> (item.beginTimestamp >= chapter.starttime && item.beginTimestamp <= chapter.endtime) || (item.endTimestamp >= chapter.starttime && item.endTimestamp <= chapter.endtime));
          item.chapterIndex = chapterIndex;
          return item;
        });
        return renderingChapterList.map((_chapter, chapterIndex) => {
          return formatKeyframeArr.filter(item=> {
            if(item.chapterIndex === chapterIndex){
              item.keyframeIndex = keyframeIndex;
              keyframeIndex++;
              return true;
            }
            return false;
          });
        });
      }
      return [];
    },
    [renderingChapterList, keyframeArr]
  );

  return (
    <div>
      {isRetrying || chapterLoading ? (
        <SummarySkeleton />
      ) : (
        <>
          {!renderingChapterList || renderingChapterList.length === 0 ? (
            <div className="flex flex-col flex-justify-center flex-items-center mt-36">
              <img src={IC_NONE} className="w-20 h-20" />
              <span className="mt-1 text-mx-quaternary text-3.5">暂无总结</span>
            </div>
          ) : (
            renderingChapterList?.map((chapter, index) => {
              const chapterKeyframes = chapterKeyframesArr[index] || [];
              const displayKeyframes = chapterKeyframes.slice(0, 3);
              const hiddenKeyframesLen = chapterKeyframes.length - displayKeyframes.length;

              return (
                <div
                  key={chapter.starttime}
                  className={`${index !== 0 && "mt-8"} flex flex-row`}
                >
                  {/* 左边的装饰 */}
                  <div className="flex-grow-0 flex flex-col items-center mr-4">
                    <div
                      className={`w-16 text-center color-#A1A7B2 lh-5 font-400 text-3 border-1 border-solid border-#DBDEE4 rounded-25 lh-5 py-.5 ${audioInfo?.audioSrc && 'cursor-pointer  active:bg-#4981F2 active:color-#fff'}`}
                      onClick={() => {
                        handleClickTimeLine(chapter.starttime / 1000);
                      }}
                    >
                      {formatRecordTime(chapter.starttime / 1000)}
                    </div>
                  </div>
                  {/* 右边的内容 */}
                  <div className="flex-1 select-text ">
                    {summaryEditing ? (
                      <Textarea
                        className="color-#30343C lh-5.5 font-500 text-3.75 mb-2 border-0 outline-0 w-full bg-transparent"
                        value={chapter.topic}
                        autoSize
                        onChange={(e) => {
                          handleTopicChange(e.target.value, index);
                        }}
                      />
                    ) : (
                      <div className="color-#30343C lh-5.5 font-500 text-3.75 mb-2">
                        {chapter.topic}
                      </div>
                    )}
                    {summaryEditing ? (
                      <Textarea
                        className="color-#626773 lh-7 font-400 text-3.5 border-0 outline-0 w-full bg-transparent"
                        value={chapter.summary}
                        autoSize
                        onChange={(e) => {
                          handleContentChange(e.target.value, index);
                        }}
                      />
                    ) : (
                      <div className="color-#626773 lh-7 font-400 text-3.5">
                        {chapter.summary}
                      </div>
                    )}
                    <Keyframe index={index} displayKeyframes={displayKeyframes} hiddenKeyframesLen={hiddenKeyframesLen} handlePreview={handlePreview} />
                  </div>
                </div>
              );
            })
          )}
          <ImagePreviewer ref={imagePreviewerRef} />
        </>
      )}
    </div>
  );
};

export default Chapter;
